import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faPenToSquare,
    faTrash,
    faUser
} from "@fortawesome/free-solid-svg-icons";
import Swal from 'sweetalert2';

const UsuarioRow = ({ usuario, onEdit, onDelete }) => {

    const handleClickModify = () => {
        onEdit(usuario);
    };

    const handleClickDelete = async () => {
        Swal.fire({
            title: `¿Está seguro que desea eliminar al usuario ${usuario.userName}?`,
            showDenyButton: true,
            confirmButtonText: 'Sí, estoy seguro',
            confirmButtonColor: '#ff0000',
            denyButtonColor: '#3d4d87',
            denyButtonText: 'No',
        }).then((result) => {
            if (result.isConfirmed) {
                onDelete(usuario);
            }
        });
    };

    const getTenantsDisplay = () => {
        if (Array.isArray(usuario.tenantsAllowed)) {
            return usuario.tenantsAllowed.map(t => t.label).join(', ');
        }
        return usuario.tenantsAllowed || '-';
    };

    return (
        <div className="usuarioRow">
            <div className="infoContainer">
                <FontAwesomeIcon icon={faUser} className="rrIcon" id="primaryIcon" />
                <div className="infoDiv">
                    <h6>Usuario:</h6>
                    <label id="codUserLabel">{usuario.userName}</label>
                </div>
                <div className="infoDiv">
                    <h6>Nombre Completo:</h6>
                    <label>{usuario.fullName}</label>
                </div>
                <div className="infoDiv">
                    <h6>Email:</h6>
                    <label>{usuario.email || '-'}</label>
                </div>
                <div className="infoDiv">
                    <h6>Tenants Permitidos:</h6>
                    <label>{getTenantsDisplay()}</label>
                </div>
                <div className="infoDiv">
                    <h6>Estado:</h6>
                    <label className={usuario.enabled ? 'enabledChip' : 'disabledChip'}>
                        {usuario.enabled ? 'Activo' : 'Inactivo'}
                    </label>
                </div>
            </div>
            <div className="funcionesDiv">
                <FontAwesomeIcon icon={faPenToSquare} onClick={handleClickModify} className="rrIcon" />
                <FontAwesomeIcon icon={faTrash} className="rrIcon" onClick={handleClickDelete} />
            </div>
        </div>
    );
};

export default UsuarioRow;
